import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ShellEffects } from './store/shell.effects';
import { shellReducer } from './store/shell.reducers';

@NgModule({
  imports: [StoreModule.forFeature(`shell`, shellReducer), EffectsModule.forFeature([ShellEffects])]
})
export class ShellStateModule {}
